import React from "react";
import { Link } from "react-router-dom";
import KYCForm from "../components/KYCForm";
import VerificationBadge from "../components/VerificationBadge";
import Footer from "../components/Footer";

import { useTranslation } from 'react-i18next';
import SEOHead from "../components/SEOHead";
export const VerifyCreatorPage = () => {
    const { t } = useTranslation();
const [status, setStatus] = React.useState(""); // "" | "submitted" | "verified"
  const [submittedData, setSubmittedData] = React.useState(null);

  const handleSubmit = (data) => {
    setSubmittedData(data);
    setStatus("submitted");
    // Simulate admin approval after 5 seconds
    setTimeout(() => {
      setStatus("verified");
    }, 5000);
  };

  return (
    <div className="min-h-screen bg-zinc-950">
      <SEOHead
        title="Verify Identity | Max Employee"
        description="Complete KYC verification to publish skills on the Marketplace. Verify your identity as a skill creator."
        url="/skills/creator/verify"
        noIndex={true}
      />
      <div className="max-w-2xl mx-auto px-6 py-12">
        {/* Header */}
        <div className="flex items-center gap-3 mb-8">
          <Link
            to="/skills"
            className="text-zinc-500 hover:text-white transition-colors"
            aria-label={t('verify_creator_page.back')}
          >
            ← Back to Marketplace
          </Link>
        </div>

        <div className="flex items-center gap-3 mb-2">
          <h1 className="text-2xl font-display font-bold text-white uppercase">{t('verify_creator_page.verify_identity')}</h1>
          {status === "verified" && (
            <VerificationBadge status="verified" />
          )}
        </div>
        <p className="text-zinc-400 text-sm mb-8">{t('verify_creator_page.complete_the_kyc_verification_to_publish_skills')}</p>

        {/* Status banners */}
        {status === "submitted" && (
          <div className="bg-amber-500/10 border border-amber-500/20 rounded-sm p-4 mb-6">
            <div className="flex items-center gap-2">
              <div className="w-5 h-5 border-2 border-amber-500 border-t-transparent rounded-full animate-spin" />
              <span className="text-amber-400 text-sm font-medium">
                Documents submitted — awaiting approval
              </span>
            </div>
            <p className="text-zinc-500 text-xs mt-1 ml-7">{t('verify_creator_page.our_team_is_reviewing_your_documents_you_will_be')}</p>
          </div>
        )}

        {status === "verified" && (
          <div className="bg-emerald-500/10 border border-emerald-500/20 rounded-sm p-4 mb-6">
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5 text-emerald-400" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="text-emerald-400 text-sm font-medium">{t('verify_creator_page.verified_you_are_now_a_verified_creator')}</span>
            </div>
            <p className="text-zinc-500 text-xs mt-1 ml-7">{t('verify_creator_page.you_can_now_publish_skills_and_receive_payments')}</p>
          </div>
        )}

        {/* KYC Form or Success */}
        {!status ? (
          <KYCForm onSubmit={handleSubmit} />
        ) : status === "verified" ? (
          <div className="text-center py-8">
            <div className="text-5xl mb-4">🎉</div>
            <h2 className="text-xl font-display uppercase text-white mb-2">{t('verify_creator_page.congratulations')}</h2>
            <p className="text-zinc-400 text-sm mb-6">{t('verify_creator_page.your_verification_has_been_approved_you_are_now_a')}</p>
            <div className="flex gap-3 justify-center">
              <Link
                to="/skills/create"
                className="bg-amber-500 hover:bg-amber-400 text-black px-6 py-3 font-bold uppercase tracking-wider text-xs transition-colors"
              >
                Publish Skill
              </Link>
              <Link
                to="/skills"
                className="border border-zinc-700 hover:border-zinc-500 text-zinc-300 hover:text-white px-6 py-3 font-mono uppercase tracking-wider text-xs transition-colors"
              >
                Explore Marketplace
              </Link>
            </div>
          </div>
        ) : (
          <div className="text-center py-8">
            <div className="text-5xl mb-4">⏳</div>
            <h2 className="text-xl font-display uppercase text-white mb-2">{t('verify_creator_page.under_review')}</h2>
            <p className="text-zinc-400 text-sm">{t('verify_creator_page.we_are_verifying_your_documents_this_may_take_a')}</p>
          </div>
        )}
      </div>
      <Footer />

    </div>
  );
};

export default VerifyCreatorPage;
